export default __webpack_public_path__ + "static/media/higg.e7777127.png";